var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"learning-control"},[(_vm.showControl)?_c('div',{staticClass:"project-controller-item pointer",on:{"click":_vm.showLearning}},[_vm._v(" "+_vm._s(_vm.localizeList.learningMode)+" ")]):_vm._e(),_c('learning-mode',{attrs:{"show":_vm.showLearningMode,"learning-info":_vm.learningInfo},on:{"hide":_vm.hideLearning}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }